import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  projectKeys,
  RequestTypes,
} from '@core/react-query/features/projects/project'
import { IProject, Project } from '@core/entities/project'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = (response: IProject) => {
  return Project.new(response)
}

export const useGetProject = (
  payload: RequestTypes['getProject'],
  options?: UseQueryOptions<IProject, RequestErrorType, Project>,
) => {
  const projectUsersQuery = projectKeys.byId(payload)
  return useQuery<IProject, RequestErrorType, Project>({
    ...projectUsersQuery,
    select: dataTransformer,
    enabled: !!payload?.projectId,
    ...options,
  })
}
